import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  hr {
    margin: 15px 0 10px 0;
    border: 1px solid #6b7786;
  }
`

export const Content = styled.div.attrs({
  scrollbarBackground: '#ffff'
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;

  padding-right: 4px;
  ${VerticalStyledScrollBar}
`

export const Footer = styled.div`
  margin-top: auto;
  padding-top: 10px;
`

export const Button = styled.button`
  height: 40px;
  padding: 0 10px;
  border: none;
  color: #fff;
  font: normal normal medium 14px/21px Inter;
  margin-right: 8px;
  cursor: pointer;
  background: #378ff7 0% 0% no-repeat padding-box;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: #fff;
    stroke: #fff;
    stroke-width: 1px;
    width: 20px;
    height: 17px;
    margin-right: 8px;
  }

  &:hover {
    background: #257ce5 0% 0% no-repeat padding-box;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`
